/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース画像アップロード成功時のレスポンスデータ
 * @export
 * @interface PostPressReleaseImageSuccessResponseData
 */
export interface PostPressReleaseImageSuccessResponseData {
    /**
     * サーバーに保存されたファイルの名前
     * @type {string}
     * @memberof PostPressReleaseImageSuccessResponseData
     */
    fileName: string;
    /**
     * s3に保存されたファイルの名前
     * @type {string}
     * @memberof PostPressReleaseImageSuccessResponseData
     */
    fileNameS3: string;
    /**
     * 画像のカラーモードがCMYKか
     * @type {boolean}
     * @memberof PostPressReleaseImageSuccessResponseData
     */
    isCMYK?: boolean;
}

export function PostPressReleaseImageSuccessResponseDataFromJSON(json: any): PostPressReleaseImageSuccessResponseData {
    return PostPressReleaseImageSuccessResponseDataFromJSONTyped(json, false);
}

export function PostPressReleaseImageSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseImageSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['file_name'],
        'fileNameS3': json['file_name_s3'],
        'isCMYK': !exists(json, 'isCMYK') ? undefined : json['isCMYK'],
    };
}

export function PostPressReleaseImageSuccessResponseDataToJSON(value?: PostPressReleaseImageSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.fileName,
        'file_name_s3': value.fileNameS3,
        'isCMYK': value.isCMYK,
    };
}

